import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Rating from '@mui/material/Rating';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------

// The website's "Loved by" badge (voolist repo,
// src/components/testimonials/SocialProofBadge.jsx): reviewer faces, the
// rating and the reseller count. Keep the count and rating in step with it.
const RESELLER_COUNT = '2900+';
const RATING = 4.8;
const REVIEWER_PHOTOS = [3, 11, 18, 24, 32].map((index) => `https://assets.voolist.com/image_${index}.jpg`);

export default function SocialProof ({ align = 'center', sx }) {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={align === 'center' ? 'center' : 'flex-start'}
      spacing={1.5}
      sx={sx}
    >
      <Stack direction="row" sx={{ flexShrink: 0 }}>
        {REVIEWER_PHOTOS.map((src, index) => (
          <Box
            key={src}
            component="img"
            src={src}
            alt=""
            width={32}
            height={32}
            loading="lazy"
            sx={{
              width: 32,
              height: 32,
              ml: index > 0 ? -1 : 0,
              borderRadius: '50%',
              objectFit: 'cover',
              border: `2px solid ${theme.palette.background.paper}`,
              position: 'relative',
              zIndex: REVIEWER_PHOTOS.length - index,
            }}
          />
        ))}
      </Stack>

      <Stack alignItems="flex-start" spacing={0.25}>
        <Rating readOnly value={RATING} precision={0.1} size="small" />
        <Typography sx={{ typography: 'body2', color: 'text.secondary', whiteSpace: 'nowrap' }}>
          Loved by{' '}
          <Box component="strong" sx={{ color: 'text.primary' }}>
            {RESELLER_COUNT} resellers
          </Box>
        </Typography>
      </Stack>
    </Stack>
  );
}

SocialProof.propTypes = {
  align: PropTypes.oneOf(['center', 'left']),
  sx: PropTypes.object,
};
